import React, { useMemo } from "react";
import "../../styles/OfficeProcedures.css";

const MANAGING_BROKERS = [
  {
    name: "Rick Sergison",
    title: "Managing Broker / Compliance Officer Canada",
    phone: "905-621-8844",
    email: "rick.sergison@exprealty.net",
  },
  {
    name: "Andrew Hopgood",
    title: "Alternate Broker of Record / Managing Broker",
    phone: "519-576-7277",
    email: "andrew.hopgood@exprealty.net",
  },
  {
    name: "Leigh Anne Murdy",
    title: "Managing Broker",
    phone: "647-365-0536",
    email: "leighanne.murdy@exprealty.net",
  },
  {
    name: "Ray Azar",
    title: "Managing Broker",
    phone: "647-260-9277",
    email: "ray.azar@exprealty.net",
  },
  {
    name: "Katherine Milian",
    title: "Broker of Record",
    phone: null,
    email: "katherine.milian@exprealty.net",
  },
];

const shuffleBrokers = (brokers) => {
  const katherine = brokers.find((broker) => broker.name === "Katherine Milian");
  const others = brokers.filter((broker) => broker.name !== "Katherine Milian");
  const shuffled = [...others];

  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
  }

  return katherine ? [...shuffled, katherine] : shuffled;
};

export default function ManagingBrokerContacts() {
  const brokers = useMemo(() => shuffleBrokers(MANAGING_BROKERS), []);

  return (
    <div className="broker-contacts-section">
      <br />
      <h2 className="clause-section-title">Managing Broker Contacts</h2>
      <div className="broker-contacts-grid">
        {brokers.map((broker) => (
          <article className="broker-contact-card" key={broker.name}>
            <h3 className="broker-contact-name">{broker.name}</h3>
            <p className="broker-contact-title">{broker.title}</p>
            <div className="broker-contact-links">
              {broker.phone ? (
                <a href={`tel:${broker.phone.replace(/[^\d+]/g, "")}`}>
                  {broker.phone}
                </a>
              ) : null}
              {broker.email ? (
                <a href={`mailto:${broker.email}`}>{broker.email}</a>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
